export const CLARITY_STATUS_OPTIONS = [
  { value: "ON_ANALYSIS", label: "clarity-status-options.on-analysis" },
  { value: "ON_VERIFICATION", label: "clarity-status-options.on-verification" },
  { value: "ON_REVIEW", label: "clarity-status-options.on-review" },
  { value: "STANDBY_FOLLOWUP", label: "clarity-status-options.standby-followup" },
  { value: "FOLLOWUP_CHECK", label: "clarity-status-options.followup-check" },
  { value: "DONE", label: "clarity-status-options.done" },
  { value: "REVERIFICATION", label: "clarity-status-options.reverification" },
  { value: "ERROR", label: "clarity-status-options.error" },
];

export const FOSSID_STATUS_OPTIONS = [
  { value: "ON_ANALYSIS", label: "fossid-status-options.on-analysis" },
  { value: "ANALYSIS_CHECK", label: "fossid-status-options.analysis-check" },
  { value: "REQUEST", label: "fossid-status-options.request" },
  { value: "ON_VERIFICATION", label: "fossid-status-options.on-verification" },
  { value: "ON_REVIEW", label: "fossid-status-options.on-review" },
  { value: "STANDBY_FOLLOWUP", label: "fossid-status-options.standby-followup" },
  { value: "FOLLOWUP_CHECK", label: "fossid-status-options.followup-check" },
  { value: "DONE", label: "fossid-status-options.done" },
  { value: "REVERIFICATION", label: "fossid-status-options.reverification" },
  { value: "ERROR", label: "fossid-status-options.error" },
];

export const SBOM_STATUS_OPTIONS = [
  { value: "ON_REVIEW", label: "sbom-status-options.on-review" },
  { value: "DONE", label: "sbom-status-options.done" },
  { value: "REVERIFICATION", label: "sbom-status-options.reverification" },
  { value: "ERROR", label: "sbom-status-options.error" },
];

export const rolePriority = {
  USER: 1,
  DEVELOPER: 2,
  ADMIN: 3,
  MANAGER: 3,
  SUPERUSER: 4,
};

export const VERIF_TYPE_SBOM_MERGE = [
  { value: "Binary", label: "verif-type-sbom-merge-options.binary" },
  { value: "Source Code", label: "verif-type-sbom-merge-options.source-code" },
  { value: "Sbom", label: "verif-type-sbom-merge-options.sbom" },
];
